import React, { forwardRef, useImperativeHandle, useState } from "react"
import { Form, Drawer, Button } from 'antd';
import { t } from "i18next";
import dataSourceYear from "./SelectYear"
import { SelectInput } from "common/elements";
import { duplicateSalaryScaleRow } from "services/salary_scale_record";
import { Util } from "common/util";

function DuplicateDrawer({ datas }, ref) {
   const [visible, setVisible] = useState(false)
   const [loading, setLoading] = useState(false)
   const [form] = Form.useForm()

   const onFinish = (values) => {
      setLoading(true);

      duplicateSalaryScaleRow(datas.data.id, values).then((response) => {
         Util.getInstance().sweetAlertMessage("Success", "success")
         datas.setYear(values.year);
         datas.fetchData(values.year);
         onClose();
      }).catch((response) => {
         if (response.response.data.error.code === 400) {
            Util.getInstance().sweetAlertMessage(`${response.response.data.error.message}`, "warning")
         }
      }).finally(() => setLoading(false));
   }

   const onClose = () => {
      setVisible(false)
      setLoading(false)
      form.setFieldsValue({
         year: undefined
      })
   }

   useImperativeHandle(ref, () => {
      return {
         showDrawer() {
            setVisible(true)
         },

      };
   }, []);
   return (
      <Drawer
         title={"Duplicate Salary Scale Record"}
         placement="right"
         closable={false}
         onClose={onClose}
         visible={visible}
      >
         <Form form={form} onFinish={onFinish}>
            <SelectInput
               style={{ margin: 0, width: "100%" }}
               errorMessage={"Please select year!"}
               name={"year"}
               required={true}
               placeholder={"Select year"}
               valueKey="id"
               dataSource={dataSourceYear}

            />


            <div className="ant-modal-footer2" style={{ position: "absolute", bottom: 0, width: "90%" }}>
               <Button
                  className="btn-cancel"
                  onClick={onClose}
                  disabled={loading}
               >
                  {t("text_cancel")}
               </Button>
               <Button
                  className="btn-save"
                  type="primary"
                  htmlType="submit"
                  disabled={loading}
                  loading={loading}
               >
                  {t("text_submit")}
               </Button>
            </div>
         </Form>
      </Drawer>
   )
}

export default forwardRef(DuplicateDrawer);
